import { evaluate } from 'mathjs';
const solveExpression = ({ expression = '', variables = {} }) => {
  const exp = [...expression];

  try {
    return evaluate(exp.join(''), variables);
  } catch (error) {
    return 0;
  }
};

export default solveExpression;
